module.exports = __webpack_public_path__ + "media/images/Logo hortense-b342f32b87d5d804a07f4c3abc84a38e.svg";